import { render } from "./BulkProductModal.vue?vue&type=template&id=643107f2&scoped=true"
import script from "./BulkProductModal.vue?vue&type=script&lang=js"
export * from "./BulkProductModal.vue?vue&type=script&lang=js"

import "./BulkProductModal.vue?vue&type=style&index=0&id=643107f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643107f2"]])

export default __exports__